import { render, staticRenderFns } from "./inflammation2.vue?vue&type=template&id=df0b77fa&scoped=true&"
import script from "./inflammation2.vue?vue&type=script&lang=js&"
export * from "./inflammation2.vue?vue&type=script&lang=js&"
import style0 from "./inflammation2.vue?vue&type=style&index=0&id=df0b77fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0b77fa",
  null
  
)

export default component.exports